import axiosClient from "api/axios_client.js"; 

const apiUserRole = {
  getAllUserRole: (payload) => axiosClient.post(`/user-role-module/user-role/get-all`, payload),
  toggleStatus: (id) => axiosClient.put(`/user-role-module/user-role/toggle-status/${id}`),
  delete: (ids) => axiosClient.delete(`/user-role-module/user-role/delete`, {data: {ids}}),
};

export default apiUserRole;


